import { Permission } from '@retail/auth/types';
import { MgPrisFeature } from '@retail/mgpris/config-types';

const withSuperuser = (adminPermissions: Permission[]): Permission[] => [
  ...adminPermissions,
  ...adminPermissions.map((perm) => new Permission({ ...perm, userRole: 'SUPERUSER' })),
];

export const featureGatedPermissions: Partial<Record<MgPrisFeature, Permission[]>> = {
  'discount-matrix': withSuperuser([
    new Permission({
      userRole: 'ADMIN',
      orgType: 'WHOLESALE_LOCATION',
      resource: 'ASSORTMENT_ITEMS',
      actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
      appTenants: ['NO', 'SE'],
    }),
    new Permission({
      userRole: 'ADMIN',
      orgType: 'WHOLESALE_LOCATION',
      resource: 'PRICE_CALCULATION__COMBINED',
      actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
      appTenants: ['NO', 'SE'],
    }),
  ]),
};
